import { t } from 'shared/core';

export function formatTimeOffAmount(amount, unit) {
  if (unit === 'hours') {
    return t('time_off.AMOUNT_IN_HOURS', {amount});
  } else if (unit === 'days') {
    return t('time_off.AMOUNT_IN_DAYS', {amount});
  } else {
    throw new Error('Unrecognized time off unit');
  }
}
